import React, {createContext, useContext, useEffect, useState} from 'react';
import {useAuth} from "../hooks/auth.hook";
import {AuthContext} from "./AuthContext";

const FilterContext = createContext();

/* Фильтры живут в sessionStorage: F5 и кнопка обновления в шапке
   (NavigationBar.handleExtraButtonClick -> window.location.reload) полностью
   перезагружают приложение, а состояние здесь обычный useState — всё набранное
   пользователем пропадало. sessionStorage, а не localStorage: фильтр это
   рабочее состояние вкладки, закрыли вкладку — начали с чистого листа.
   Запись привязана к сотруднику: после входа под другим пользователем чужие
   фильтры (в том числе по филиалу) подставляться не должны. */
const STORAGE_KEY = 'filterValues'

const readStoredFilters = (empId) => {
    if (!empId) return null
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY)
        if (!raw) return null
        const parsed = JSON.parse(raw)
        if (!parsed || typeof parsed.values !== 'object' || parsed.values === null) return null
        return String(parsed.empId) === String(empId) ? parsed.values : null
    } catch (e) {
        /* Приватный режим, запрет на хранилище, битый JSON — фильтры просто
           не восстановятся, падать из-за этого нельзя. */
        return null
    }
}

export const FilterProvider = ({ children }) => {
    const auth = useContext(AuthContext);

    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, '0');
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const year = currentDate.getFullYear();

    const formattedCurrentDate = `${day}.${month}.${year}`;

    //console.log(auth.empFilial,'auth.empFilial')
    /*const defFilter = auth.empFilial === "000" ?
      {"paydocTabFilter": [
              {
                  column: 'filial',
                  operator: '=',
                  value: '000',
                  dataType: 'text',
              },
          ],
       "paydocAccFilter": [
              {
                  column: 'filial',
                  operator: '=',
                  value: '000',
                  dataType: 'text',
              },
          ]
      } : {}*/

    const [filterValues, setFilterValues] = useState({});

    useEffect(() => {
        // Update default filter values based on the condition
        const defFilter = auth.empFilial === "000" ?
            {
                "paydocTabFilter": [
                    {
                        column: 'filial',
                        operator: 'in',
                        value: ['000'],
                        dataType: 'text',
                    },
                ],
                "paydocAccFilter": [
                    {
                        column: 'filial',
                        operator: 'in',
                        value: ['000'],
                        dataType: 'text',
                    },
                ],
                "CardContractsFilter": [
                    {
                        column: 'mbat_filial',
                        operator: 'in',
                        value: ['000'],
                        dataType: 'text',
                    },
                ],
                "bankAccSaldoPeriodFilters": [
                    {
                        "column": "date_saldo",
                        "operator": "range",
                        "value": formattedCurrentDate,
                        "value2": formattedCurrentDate,
                        "dataType": "date"
                    },
                ],
                "contractTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    },
                    {
                        column: 'filial',
                        operator: 'in',
                        value: ['000'],
                        dataType: 'text',
                    },
                ],
                "cashAppTabFilter": [
                    {
                        "column": "fin_year",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "smetaTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "smetaOldTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "smetaExecuteTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "contractExecuteTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "cashAppExecuteTabFilter": [
                    {
                        "column": "fin_year",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                /*"smetaTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ]*/
            } : {
                "bankAccSaldoPeriodFilters": [
                    {
                        "column": "date_saldo",
                        "operator": "range",
                        "value": "26.12.2023",
                        "value2": "26.12.2023",
                        "dataType": "date"
                    },
                ],
                "contractTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "cashAppTabFilter": [
                    {
                        "column": "fin_year",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "smetaTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "smetaExecuteTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "contractExecuteTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "cashAppExecuteTabFilter": [
                    {
                        "column": "fin_year",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ],
                "CardContractsFilter": [
                    {
                        "column": "mbat_filial",
                        "operator": "in",
                        "value": [auth.empFilial],
                        "dataType": "text"
                    }
                ],
                /*"smetaTabFilter": [
                    {
                        "column": "finyear",
                        "operator": "=",
                        "value": year,
                        "dataType": "number"
                    }
                ]*/
            };

        /* Сохранённое важнее значений по умолчанию: иначе этот же эффект
           затирал бы восстановленный фильтр. Ключи, которых в сохранённом нет,
           берутся из defFilter, а явно очищенный пользователем фильтр лежит в
           хранилище пустым массивом и остаётся очищенным. */
        const stored = readStoredFilters(auth.empId)
        setFilterValues(stored ? {...defFilter, ...stored} : defFilter);
    }, [auth.empFilial, auth.empId]);

    /* Писать до того, как сеанс поднят из localStorage, нельзя: на первом
       рендере empId ещё null, и запись с пустым empId стёрла бы то, что
       эффект выше вот-вот прочитает. */
    useEffect(() => {
        if (!auth.empId || Object.keys(filterValues).length === 0) return
        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify({empId: auth.empId, values: filterValues}))
        } catch (e) {
            console.error('Filter save error: ' + e)
        }
    }, [filterValues, auth.empId]);

    const updateFilterValues = (newFilterValues) => {
        setFilterValues((prevFilterValues) => ({
            ...filterValues,
            ...prevFilterValues,
            ...newFilterValues,

        }));
    };


    return (
        <FilterContext.Provider value={{ filterValues, updateFilterValues }}>
            {children}
        </FilterContext.Provider>
    );
};

export const useFilter = () => {
    return useContext(FilterContext);
};